import React from "react";
import { Modal, Form, Button, ListGroup } from "react-bootstrap";
import { DragDropContext, Droppable } from "react-beautiful-dnd";

export default function TypesPlvOrderRapport({
  showUpdateOrderRapport,
  updateOrder,
  itemsList,
  handleClose,
  onDragEnd,
  ListItem
}) {
  return (
    <Modal
      size="lg"
      show={showUpdateOrderRapport}
      onHide={() =>
        window.confirm("Êtes-vous sûr de quitter sans valider ?")
          ? handleClose()
          : ""
      }
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Organiser l'ordre d'affichage des types de PLV dans le rapport
        </Modal.Title>
      </Modal.Header>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          updateOrder(itemsList);
        }}
      >
        <Modal.Body>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
              {(provided) => (
                <ListGroup {...provided.droppableProps} ref={provided.innerRef}>
                  {itemsList.map((item, index) => (
                    <ListItem key={item.id} item={item} index={index} />
                  ))}
                  {provided.placeholder}
                </ListGroup>
              )}
            </Droppable>
          </DragDropContext>
        </Modal.Body>
        <Modal.Footer className="is-bottom-right">
          <Button
            variant="secondary"
            className="button grey-dark-button"
            onClick={handleClose}
          >
            Annuler
          </Button>
          <Button type="submit" className="button green-button">
            Valider
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
